import { render, staticRenderFns } from "./DocumentsWin.vue?vue&type=template&id=1aac9127&"
import script from "./DocumentsWin.vue?vue&type=script&lang=js&"
export * from "./DocumentsWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports